export default __webpack_public_path__ + "static/203-ce70625aae62868da65571ea13b0a2b3.jpg";